import api from '@/lib/api/crate-core-api-client'
import { resolveAttributionEndpoint } from '@/lib/attribution/client'
import { withAttributionData } from '@/lib/attribution/auth'
import { attributionDebug, attributionWarn } from '@/lib/attribution/logger'

type LoginCredentials = {
  identifier: string
  password: string
  signal?: AbortSignal
}

const getLoginIdentifierPayload = (identifier: string) => {
  const normalizedIdentifier = identifier.trim()

  if (normalizedIdentifier.includes('@')) {
    return { email: normalizedIdentifier }
  }

  return { username: normalizedIdentifier }
}

export async function login({ identifier, password, signal }: LoginCredentials) {
  const endpoint = resolveAttributionEndpoint('login')
  const payload = withAttributionData({
    ...getLoginIdentifierPayload(identifier),
    password,
  })

  attributionDebug('Preparing login request', {
    endpoint: endpoint.primary,
    hasAttributionData: !!payload.anonymous_id,
  })

  try {
    const response = await api.post<{
      access_token: string
      refresh_token: string
    }>(endpoint.primary, payload, { signal })
    attributionDebug('Login request succeeded', {
      endpoint: endpoint.primary,
    })

    return {
      accessToken: response.data.access_token,
      refreshToken: response.data.refresh_token,
    }
  } catch (error) {
    attributionWarn('Login request failed', {
      endpoint: endpoint.primary,
    })
    throw error
  }
}
